import { render, staticRenderFns } from "./AdminUsersView.vue?vue&type=template&id=406b0e7c&scoped=true"
import script from "./AdminUsersView.vue?vue&type=script&lang=js"
export * from "./AdminUsersView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b0e7c",
  null
  
)

export default component.exports